import React, { useState, useEffect } from "react";
import fondo from "./ismaael.jpeg";
import "./ComicPagina.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import MenuPrincipal from "./MenuPrincipal";

const ComicPagina = ({ comics = [] }) => {
const navigate = useNavigate();
const { num } = useParams();

const paginaActual = Number(num) || 1;
const comicsPorPagina = 24;


  
const totalPaginas = Math.ceil(comics.length / comicsPorPagina);
const inicio = (paginaActual - 1) * comicsPorPagina;
const comicsVisibles = comics.slice(inicio,inicio+comicsPorPagina);

  const srcImg = (img) => img?.startsWith("http") ? img : `/${img}`;

  useEffect(() => {
    const cards = document.querySelectorAll(".comic-card");

    cards.forEach((card) => {
      const handleMove = (e) => {
        const rect = card.getBoundingClientRect();
        card.style.setProperty("--x", `${e.clientX - rect.left}px`);
        card.style.setProperty("--y", `${e.clientY - rect.top}px`);
      };

      card.addEventListener("mousemove", handleMove);
    });

    return () => {
      cards.forEach((card) => {
        const newCard = card.cloneNode(true);
        card.replaceWith(newCard);
      });
    };
  }, []);

 return (
  <div>
    <header
      className="header-fondo"
      style={{
        background: `url(${fondo}) no-repeat center center/cover`,
        padding: "40px 0",
        textAlign: "center",
        color: "#fff",
      }}
    >
      <h1
        className="titulo"
        onClick={() => navigate("/")}
        style={{ cursor: "pointer" }}
      >
        TMOXNight
      </h1>

      <MenuPrincipal />
    </header>

    <main>

      <section className="comics-populares ultra">
        <h2>⚡ Cómics Populares</h2>

        <div className="populares-ultra">
          {[
            { titulo: "Kimetsu no Yaiba", img: "sera.png" },
            { titulo: "Jujutsu Kaisen", img: "arc.jpeg" },
            { titulo: "Chainsaw Man", img: "sera.png" },
            { titulo: "Attack on Titan", img: "arc.jpeg" },
            { titulo: "Blue Lock", img: "sera.png" },
            { titulo: "Death Note", img: "arc.jpeg" },
          ].map((comic, i) => (
            <div className="comic-card" key={i}>
              <div className="glow"></div>

              <img src={comic.img} alt={comic.titulo} />

              <div className="info">
                <h3>{comic.titulo}</h3>

                <button>Leer Ahora</button>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="catalogo">
        <h2>Cómics Nuevos</h2>

        <div className="grid">
          {comicsVisibles.map((comic) => (
            <div className="comic-new-card" key={comic.id}>
              <img
                src={srcImg(comic.imagen)}
                alt={comic.nombre}
              />

              <div className="info">
                <h3>{comic.nombre}</h3>

                <Link
                  to={comic.enlace}
                  className="comic-new-btn"
                >
                  Leer Comic
                </Link>
              </div>
            </div>
          ))}
        </div>

        <div id="pagination" style={{ marginTop: 20, textAlign: "center" }}>
          {Array.from({ length: totalPaginas }).map((_, i) => (
            <button
              key={i}
              className={`page-number ${
                i + 1 === paginaActual ? "active" : ""
              }`}
onClick={() =>
  navigate(i === 0 ? "/" : `/page/${i + 1}`)
}            >
              {i + 1}
            </button>
          ))}

          {paginaActual < totalPaginas && (
            <button
              id="next-page"
onClick={() =>
  navigate(`/page/${paginaActual + 1}`)
}            >
              Siguiente
            </button>
          )}
        </div>
      </section>

    </main>

    <footer>
      <p>
        &copy; 2024 TMOXNight. Todos los derechos reservados.
      </p>
    </footer>
  </div>
);
};

export default ComicPagina;